import { createFileRoute } from '@tanstack/react-router'
import ConceptApproval from 'Concept/components/Concept/Sections/ConceptApproval/ConceptApproval'

export const Route = createFileRoute('/concept/$conceptId/approval')({
    component: ConceptApproval,
})
